import * as TypeGraphQL from "type-graphql";
export var SignalGeneratorSource;
(function (SignalGeneratorSource) {
    SignalGeneratorSource["ENHANCED"] = "ENHANCED";
    SignalGeneratorSource["PRODUCTION"] = "PRODUCTION";
    SignalGeneratorSource["LLM"] = "LLM";
    SignalGeneratorSource["HYBRID"] = "HYBRID";
    SignalGeneratorSource["EVENT_DRIVEN"] = "EVENT_DRIVEN";
    SignalGeneratorSource["ML_PREDICTION"] = "ML_PREDICTION";
    SignalGeneratorSource["OPTIONS_SCREENER"] = "OPTIONS_SCREENER";
    SignalGeneratorSource["TECHNICAL_ANALYSIS"] = "TECHNICAL_ANALYSIS";
    SignalGeneratorSource["FUNDAMENTAL"] = "FUNDAMENTAL";
    SignalGeneratorSource["SENTIMENT"] = "SENTIMENT";
    SignalGeneratorSource["CUSTOM"] = "CUSTOM";
})(SignalGeneratorSource || (SignalGeneratorSource = {}));
TypeGraphQL.registerEnumType(SignalGeneratorSource, {
    name: "SignalGeneratorSource",
    description: undefined,
});
//# sourceMappingURL=SignalGeneratorSource.js.map